/**
 * VMK UI Kit browser bundle entry.
 * Mirrors the public API surface of gnexus-ui-kit for compatibility.
 */

import Helper from "./components/helper.js";
import * as Icons from "./components/icon-helper.js";
import Toasts from "./components/toasts.js";
import Modals from "./components/modals.js";
import Drawer from "./components/drawer.js";
import confirmPopup from "./components/confirm-popup.js";
import InputPatterns from "./components/input-patterns.js";
import editableString from "./components/editable-string.js";
import Overlays from "./components/overlays.js";
import advancedSelect from "./components/advanced-select.js";
import Tabs from "./components/tabs.js";
import Progress from "./components/progress.js";
import Tables from "./components/tables.js";
import Lists from "./components/lists.js";
import Skeleton from "./components/skeleton.js";
import Tooltips from "./components/tooltips.js";
import Dropdowns from "./components/dropdowns.js";
import NavigationShell from "./components/navigation-shell.js";
import Background from "./components/backgrounds.js";
import Breadcrumbs from "./components/breadcrumbs.js";
import Accordion from "./components/accordion.js";
import Popover from "./components/popover.js";
import Loader from "./components/loader.js";

const api = {
  Helper,
  Icons,
  Toasts,
  Modals,
  Drawer,
  confirmPopup,
  InputPatterns,
  editableString,
  Overlays,
  advancedSelect,
  Tabs,
  Progress,
  Tables,
  Lists,
  Skeleton,
  Tooltips,
  Dropdowns,
  NavigationShell,
  Background,
  Breadcrumbs,
  Accordion,
  Popover,
  Loader
};

if (typeof window !== "undefined") {
  window.GNexusUIKit = api;
  window.VMKUIKit = api;
  Object.assign(window, api);

  document.addEventListener("DOMContentLoaded", () => {
    Background.init?.();
    Breadcrumbs.init?.();
    Accordion.init?.();
    Tabs.init?.();
    Dropdowns.init?.();
    Tooltips.init?.();
    Popover.init?.();
    Loader.init?.();
    NavigationShell.init?.();
    InputPatterns.init?.();
    Overlays.init?.();
  });
}

export { Helper, Icons, Toasts, Modals, Drawer, confirmPopup, InputPatterns, editableString, Overlays, advancedSelect, Tabs, Progress, Tables, Lists, Skeleton, Tooltips, Dropdowns, NavigationShell, Background, Breadcrumbs, Accordion, Popover, Loader };
export default api;
